import React from 'react';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';
import KwPanel from '../../common/KwPanel';
import { toast } from 'react-toastify';
import { disableKeys } from '../../../actions/keyCodeActions';
import type { DisableKeysParams } from '../../../api/keyCodeApi';
import { Link } from 'react-router-dom';
import Button from '../../common/Button';
import ConfirmationHeader from '../../common/ConfirmationHeader';
import { Trans, useTranslation } from 'react-i18next';

export interface DisableUnusedKeysProps {
  done: (d?: any) => void;
  skuId: string;
  skuName: string;
  keyWorkflowId: string;
  keyWorkflowName: string;
  gameName: string;
  cancel: () => void;
}

function DisableUnusedKeys({
  done,
  skuId,
  skuName,
  keyWorkflowId,
  keyWorkflowName,
  gameName,
  cancel,
}: DisableUnusedKeysProps) {
  const { t } = useTranslation();
  const SuccessToast = () => (
    <div>
      {t('Keys queued to be disabled')}
      <br />
      <Link to="/keys/reported-disabled">{t('View queue')}</Link>
    </div>
  );

  const handleArchive = () => {
    const a: DisableKeysParams = {
      reason: t(
        'Disable unused keys in "{keyWorkflowName}" keypool on "{gameName} - {skuName}"',
        {
          keyWorkflowName,
          gameName,
          skuName,
        }
      ),
      targetGameSKUId: skuId,
      targetKeyWorkflowId: keyWorkflowId,
      targetIsAvailable: true,
    };
    disableKeys(a)
      .then((d) => {
        toast.success(SuccessToast);
        done(d);
      })
      .catch((e) => {
        toast.error(e.message || t('Failed to enqueue disable keys request'));
      });
  };

  return (
    <SlideoutLayout
      title={t('Disable confirmation')}
      cancel={cancel}
    >
      <KwPanel>
        <ConfirmationHeader />
        <p>
          <Trans
            i18nKey="disableAllCodesForSKU"
            components={{ bold: <b /> }}
            values={{
              gameName,
              skuName,
              keyWorkflowName,
            }}
          >
            This will disable all pooled codes for this SKU <b>"{gameName}"</b> -{' '}
            <b>"{skuName}"</b> and key workflow <b>"{keyWorkflowName}"</b> that are
            currently "available".
          </Trans>
        </p>
        <hr />
        <Button
          className="btn btn-danger me-2"
          onClick={handleArchive}
          text={t('Yes, disable the codes')}
        />
        <Button
          className="btn btn-default"
          onClick={cancel}
          autoFocus={true}
          text={t('No, cancel')}
        />
      </KwPanel>
    </SlideoutLayout>
  );
}

export default DisableUnusedKeys;
